module.exports = __webpack_public_path__ + "static/media/AboutContent-4.08d1202e.png";